import React from 'react'
import { Row, Col } from 'reactstrap'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

const ServicesSection = ({ data }) => {
  return (
    <section>
      <div className="about-services-section">
        <div className="about-services-title-text">
          <div className="about-services-title">{data.title}</div>
          <div className="about-services-text">{data.text}</div>
        </div>

        <Row className="about-services-row">
          {data.services
            .map(i => i.fields)
            .map((i, index) => {
              return (
                <Col xs="12" sm="6" key={index} className="about-services-categories-wrapper">
                  <img
                    className="about-services-categories-image"
                    src={i.icon.fields.file.url}
                    alt={i.altImageText}
                    loading="lazy"
                  />
                  <div>
                    <div className="about-services-categories-title">{i.title}</div>
                    <div className="about-services-categories-description">
                      {documentToReactComponents(i.text)}
                    </div>
                  </div>
                </Col>
              )
            })}
        </Row>
      </div>
    </section>
  )
}
export default ServicesSection
